// @owners { team: patients }
import { Body, Icon, Row } from '@alto/design-system';
import React from 'react';

type Props = {
  label: string;
  price: string;
  quantity?: string;
};

export const AttestationPriceRow = ({ label, price, quantity }: Props) => {
  const priceText = quantity ? `${label}: ${price} (${quantity})` : `${label}: ${price}`;

  return (
    <Row
      centerVertically
      flexShrink={1}
      gap="XS"
    >
      <Icon
        name="pricetag-small"
        type="grey"
      />
      <Row
        centerVertically
        flexShrink={1}
        wrap
      >
        <Body>{priceText}</Body>
      </Row>
    </Row>
  );
};
